(function () {
	'use strict';

	angular.module('widgets.initiative')
		.service('inventoryActionResultsService', inventoryActionResultsService);

	function inventoryActionResultsService($http, URLS) {
		return {
			getInventoryActionResultsData: getInventoryActionResultsData
		};

		function getInventoryActionResultsData(filterService, ignoreFilters, pastTimePeriod, futureTimePeriod, customDateOne, customDateTwo) {
			var url = String.format(URLS.host + URLS.inventoryActionStatus,
				filterService.getFactoryList());

			var filterQueryParams = filterService.getQueryParamsObject(true);
			filterQueryParams['dataType'] = 'Savings';
			filterQueryParams['dateToGroupBy'] = 'targetDate';
			if (pastTimePeriod != null) {
				filterQueryParams['pastTimePeriod'] = pastTimePeriod;
			}
			if (futureTimePeriod != null) {
				filterQueryParams['futureTimePeriod'] = futureTimePeriod;
			}
			filterQueryParams['startTimestamp'] = customDateOne.getTime();
			filterQueryParams['endTimestamp'] = customDateTwo.getTime();

			if (ignoreFilters) {
				filterQueryParams = _.omit(filterQueryParams, ignoreFilters);
			}

			url = addQueryParam(url,
				filterService.getFactoryList(), filterQueryParams, false);

			return $http.get(url)
				.then(getInventoryActionResultsDataComplete)
				.catch(getInventoryActionResultsDataFailed);

			function getInventoryActionResultsDataComplete(response) {
				if (response && response.data){
					return response.data;
				}
				return [];
			}
			function getInventoryActionResultsDataFailed(error) {
				return error;
			}
		}
	}
})();
